// constants
const SET_USER = 'session/SET_USER';
const REMOVE_USER = 'session/REMOVE_USER';
const GET_USER = 'session/GET_USER';
const GET_USERS = 'session/GET_USERS';

const setUser = (user) => ({
  type: SET_USER,
  payload: user
});

const removeUser = () => ({
  type: REMOVE_USER,
})

const getUser = (user) => ({
  type: GET_USER,
  user
})

const loadUsers = (users) => ({
  type: GET_USERS,
  users
})

export const getOneUser = userId => async(dispatch) => {
  // For frontend-only demo, return mock user data
  const mockUser = {
    id: userId,
    username: userId === 1 ? 'demo_user' : 'alice_smith',
    email: userId === 1 ? 'demo@venmo.com' : 'alice@venmo.com',
    name: userId === 1 ? 'Demo User' : 'Alice Smith'
  };
  dispatch(getUser(mockUser));
}

export const getUsers = () => async(dispatch) => {
  const { userService } = await import('../utils/userService');
  
  const users = userService.getAllUsers();
  dispatch(loadUsers({ users }));
}

const initialState = { user: null };

export const authenticate = () => async (dispatch) => {
  // Check if user is stored in localStorage
  const savedUser = localStorage.getItem('venmo_current_user');
  if (savedUser) {
    const user = JSON.parse(savedUser);
    dispatch(setUser(user));
  }
}

export const login = (email, password) => async (dispatch) => {
  const { userService } = await import('../utils/userService');
  
  const user = userService.authenticate(email, password);
  if (user) {
    localStorage.setItem('venmo_current_user', JSON.stringify(user));
    dispatch(setUser(user));
    return null;
  } else {
    return ['Invalid email or password'];
  }
}

export const logout = () => async (dispatch) => {
  localStorage.removeItem('venmo_current_user');
  dispatch(removeUser());
};


export const signUp = (username, email, name, password) => async (dispatch) => {
  // For frontend-only demo, simulate a successful signup
  const mockUser = {
    id: 1,
    username: username,
    email: email,
    name: name
  };
  
  dispatch(setUser(mockUser));
  return null;
}

export default function reducer(state = initialState, action) {
  let newState ={ ...state };
  switch (action.type) {
    case SET_USER:
      return { user: action.payload }
    case REMOVE_USER:
      return { user: null }
    case GET_USER:
        newState[action.user.id] = action.user;
      return newState;
    case GET_USERS:
      if(action.users) {
        action.users.users.forEach(
          (user) => (newState[user.id] = user)
        )
      } else {
        newState = {}
      }
      return newState;
    default:
      return state;
  }
}
